import React, {useMemo, useCallback, useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate, useParams} from 'react-router-dom';
import {ProjectDetailsPageParams} from '../vehicleProjectPagePaths';
import {
	useAggregateVehicleProjectGroupMutation,
	useAggregateVehicleProjectsMutation,
} from '../hooks';
import {useUserContext} from 'authentication/UserContext';
import {ConfirmAggregateDialog} from 'components/Dialogs/ConfirmAggregateDialog/ConfirmAggregateDialog';

export const AggregateVehicleProjectDialog: React.FC = () => {
	const {t} = useTranslation('features/vehicleprojects', {
		keyPrefix: 'AggregateProjectDialog',
	});
	const navigate = useNavigate();

	const {modelSeries, generation} = useParams() as ProjectDetailsPageParams;

	const [aggregateVehicleProject] = useAggregateVehicleProjectGroupMutation();

	const {isAdmin, isBedarfskoordinator} = useUserContext();

	const handleConfirm = async () => {
		await aggregateVehicleProject({variables: {modelSeries, generation}});
		navigate(0);
	};

	return (
		<ConfirmAggregateDialog
			buttonKey='aggregateProject'
			buttonText={t('AggregateProject')}
			buttonHidden={!(isAdmin || isBedarfskoordinator)}
			handleConfirm={handleConfirm}
			dialogText={t('AggregateProjectText')}
			dialogTitle={t('AggregateProjectTitle')}
		/>
	);
};

export const AggregateVehicleProjectsDialog: React.FC = () => {
	const {t} = useTranslation('features/vehicleprojects', {
		keyPrefix: 'AggregateProjectDialog',
	});

	const [aggregateVehicleProjects] = useAggregateVehicleProjectsMutation();

	const {isAdmin, isBedarfskoordinator} = useUserContext();

	const handleConfirm = () => {
		aggregateVehicleProjects();
	};

	return (
		<ConfirmAggregateDialog
			buttonKey='aggregateProjects'
			buttonText={t('AggregateProjects')}
			buttonHidden={!(isAdmin || isBedarfskoordinator)}
			handleConfirm={handleConfirm}
			dialogText={t('AggregateProjectsText')}
			dialogTitle={t('AggregateProjectsTitle')}
		/>
	);
};
